import React from 'react';
import { Button } from 'primereact/button';
import './ControlPanelMolecule.scss';

export interface ControlPanelMoleculeProps {
  isPlaying: boolean;
  onPlay?: () => void;
  onPause?: () => void;
  onStop?: () => void;
  showStop?: boolean;
  className?: string;
  disabled?: boolean;
}

const ControlPanelMolecule: React.FC<ControlPanelMoleculeProps> = ({
  isPlaying,
  onPlay,
  onPause,
  onStop,
  showStop = true,
  className = '',
  disabled = false,
}) => {
  return (
    <div className={`control-panel-molecule ${className}`}>
      <div className="control-panel-buttons">
        {/* Left button - Back (mocked, no functionality) */}
        <Button
          icon="pi pi-step-backward-alt"
          disabled={disabled}
          className="control-panel-button control-panel-button--back"
          aria-label="Back"
          tooltip="Back"
          tooltipOptions={{ position: 'top' }}
        />
        {/* Middle button - Pause */}
        <Button
          icon="pi pi-pause"
          onClick={onPause}
          disabled={disabled}
          className={`control-panel-button control-panel-button--pause ${isPlaying ? '' : 'active'}`}
          aria-label="Pause"
          tooltip="Pause"
          tooltipOptions={{ position: 'top' }}
        />
        {/* Right button - Play */}
        <Button
          icon="pi pi-play"
          onClick={onPlay}
          disabled={disabled}
          className={`control-panel-button control-panel-button--play ${isPlaying ? 'active' : ''}`}
          aria-label="Play"
          tooltip="Play"
          tooltipOptions={{ position: 'top' }}
        />
      </div>
    </div>
  );
};

export default ControlPanelMolecule;
